import { useTheme } from '@emotion/react'

import Redirect from 'components/Redirect'
import RulesSection from 'components/advanced-settings/rules/RulesSection'
import useSectionOpenedTracking from 'hooks/useSectionOpenedTracking'
import useTemplateId from 'hooks/useTemplateId'
import AdvancedSettingsLayout from 'layouts/AdvancedSettingsLayout'

function Rules() {
	useSectionOpenedTracking()
	const { withTemplateId } = useTemplateId()
	const theme = useTheme()

	if (theme.isMobile) {
		return <Redirect to={withTemplateId('/configurator/widget-content')} />
	}

	return <AdvancedSettingsLayout leftColumn={<RulesSection />} rightColumn={null} headingChildrenPosition="right" />
}

export default Rules
